import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import { InputText, Form, Button, Spin } from "common/elements";
import { getOne, insertNewRecord, updateRecordById } from "services/job_level";

export default class FormInsertOrUpdate extends React.PureComponent {
  state = {
    isModalVisible: false,
    id: null,
    loading: false,
    disabled: false,
    loadingFormData: false,
  };

  showModal = (id) => {
    if (id) {
      this.setState({ loadingFormData: true, isModalVisible: true });
      getOne(id)
        .then((response) => {
          if (response) {
            const formData = response.data;
            this.props.form.setFieldsValue({
              name: formData.name,
            });
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            this.props.navigate("/signin");
          }
        })
        .finally(() => {
          this.setState({
            isModalVisible: true,
            id,
            loadingFormData: false,
          });
        });
    } else {
      this.setState({
        isModalVisible: true,
        id: null,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      isModalVisible: false,
      disabled: false,
    });
  };

  onFinish = (values) => {
    this.setState({ loading: true });
    if (this.state.id) {
      updateRecordById(this.state.id, values)
        .then(() => {
          this.setState({ isModalVisible: false });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    } else {
      insertNewRecord(values)
        .then(() => {
          this.setState({ isModalVisible: false });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    const { isModalVisible, loading, loadingFormData, id, disabled } =
      this.state;
    return isModalVisible ? (
      <Modal
        title={id ? t("text_edit_job_level") : t("text_new_job_level")}
        visible={isModalVisible}
        onCancel={this.handleCancel}
      >
        <Spin spinning={loadingFormData}>
          <Form
            form={this.props.form}
            key={id}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >
            <InputText
              name="name"
              label={t("text_name")}
              placeholder={t("text_name")}
              requiredMessage={t("text_please_input_name")}
              isAutoSelect={true}
            />
            <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={this.handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t("text_save")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    ) : (
      <div />
    );
  }
}
